import { render, staticRenderFns } from "./Canals.vue?vue&type=template&id=3a86feb6&scoped=true&"
import script from "./Canals.vue?vue&type=script&lang=js&"
export * from "./Canals.vue?vue&type=script&lang=js&"
import style0 from "./Canals.vue?vue&type=style&index=0&id=3a86feb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a86feb6",
  null
  
)

export default component.exports